const saveLocation = data => {
  try {
    localStorage.setItem('ref', JSON.stringify(data));
  } catch (err) {} // eslint-disable-line
};

export default () => next => action => {
  next(action);
  if (action.type !== 'ROUTE_LOADED' || !action.route) {
    return;
  }
  const { data, route, location } = action;
  const name = route.name;

  const path = location.pathname + location.search;

  switch (name) {
    case 'product':
    case 'category':
    case 'campaign':
    case 'store':
    case 'brand':
    case 'shopOfTheYearLandingPage':
    case 'shopOfTheYearCategory':
    case 'search':
    case 'infoPage':
    case 'article':
    case 'productCompare':
    case 'productAlert':
    case 'productCollection':
    case 'createPurchaseReview':
    case 'editPurchaseReview':
    case 'user':
      saveLocation({
        path,
        name: data && data[name] && data[name].name,
      });
      break;
    case 'start':
      saveLocation({
        path,
      });
      break;
    default:
  }
};
